import { getGuide } from "@/lib/content";
import type { IntakeSource } from "@/config/intake";
import type { IntakeContext } from "@/types/intake";
import type { IdentityId, SchoolId } from "@/types/navigation";

type CreateIntakeOptions = Partial<Omit<IntakeContext, "source">> & { source: IntakeSource };

/** 各入口统一构造留资上下文；无攻略页时 school/identity 在表单内选择。 */
export function createIntakeContext(opts: CreateIntakeOptions): IntakeContext {
  const { school, identity, regions, criterion, ...rest } = opts;

  let resolvedRegions = regions ?? [];
  if (resolvedRegions.length === 0 && school && identity) {
    resolvedRegions = getGuide(school, identity)?.regions ?? [];
  }

  return {
    school,
    identity,
    regions: resolvedRegions,
    criterion: criterion ?? null,
    ...rest,
    source: opts.source,
  };
}

export function intakeFromGuide(
  school: SchoolId,
  identity: Exclude<IdentityId, "other">,
  extra: Partial<Omit<IntakeContext, "school" | "identity" | "regions">> & {
    source?: IntakeSource;
  } = {},
): IntakeContext {
  const guide = getGuide(school, identity);
  return createIntakeContext({
    school,
    identity,
    regions: guide?.regions ?? [],
    source: extra.source ?? "section4",
    ...extra,
  });
}
